// Bo'lajak tarbiyachilarning kasbiy-metodik kompetensiyasi diagnostikasi.
// Kirish va chiqish bosqichlarida bir xil instrument qo'llaniladi —
// natijalarni taqqoslash (pedagogik tajriba samaradorligi) shunga asoslanadi.

export const likertScale = [
    "Mutlaqo qo'shilmayman",
    "Qo'shilmayman",
    "Bilmayman",
    "Qo'shilaman",
    "To'liq qo'shilaman",
];

export const levels = [
    { id: "past", label: "Past", min: 0, color: "#ef4444" },
    { id: "orta", label: "O'rta", min: 55, color: "#f59e0b" },
    { id: "yuqori", label: "Yuqori", min: 80, color: "#10b981" },
];

export const getLevel = (percent) =>
    [...levels].reverse().find((l) => percent >= l.min) || levels[0];

export const stages = {
    pre: { label: "Kirish diagnostikasi", short: "Kirish" },
    post: { label: "Chiqish diagnostikasi", short: "Chiqish" },
};

export const components = [
    {
        id: "motivational",
        title: "Motivatsion-qadriyatli komponent",
        short: "Motivatsion",
        icon: "icon-star",
        description: "Tarbiyachilik kasbiga, innovatsion metodlarni o'rganish va qo'llashga bo'lgan qiziqish va ichki ehtiyoj.",
        type: "likert",
        items: [
            "Men maktabgacha ta'lim tashkilotida tarbiyachi bo'lib ishlashni chin dildan xohlayman.",
            "Xorijiy davlatlarning maktabgacha ta'lim tajribasini o'rganish menga qiziq.",
            "Yangi metodlarni o'rganish uchun darsdan tashqari vaqt ajrataman.",
            "Bolalar bilan ishlashda bir xil usullardan foydalanish meni qoniqtirmaydi.",
            "Kasbiy-metodik tayyorgarligim kelajakdagi ish samaramni belgilaydi deb hisoblayman.",
            "Pedagogik amaliyotda o'rgangan metodlarimni sinab ko'rishga intilaman.",
        ],
    },
    {
        id: "cognitive",
        title: "Kognitiv (bilim) komponent",
        short: "Kognitiv",
        icon: "icon-files",
        description: "Maktabgacha ta'lim metodikasi, zamonaviy interfaol metodlar va ularning qo'llanish shartlari haqidagi bilimlar.",
        type: "test",
        items: [
            { q: "Maktabgacha yoshdagi bolalarning yetakchi faoliyat turi qaysi?", options: ["O'quv faoliyati", "O'yin faoliyati", "Mehnat faoliyati", "Muloqot faoliyati"], correct: 1 },
            { q: "SMART modeli mashg'ulotning qaysi elementini loyihalashda qo'llaniladi?", options: ["Maqsadni aniq belgilashda", "Xonani bezashda", "Ota-onalar yig'ilishida", "Bolalarni guruhlarga ajratishda"], correct: 0 },
            { q: "3I metodidagi \"Individualizatsiya\" tarbiyachidan nimani talab qiladi?", options: ["Barcha bolaga bir xil topshiriq berishni", "Har bir bolaning ehtiyoji va imkoniyatini hisobga olishni", "Faqat iqtidorli bolalar bilan ishlashni", "Mashg'ulotni yakka tartibda o'tkazishni"], correct: 1 },
            { q: "CLIL yondashuvining mohiyati nimada?", options: ["Faqat chet tilini o'rgatish", "Mazmun va tilni integratsiyalashgan holda o'rgatish", "Bolalarni test orqali baholash", "Rasm chizishga o'rgatish"], correct: 1 },
            { q: "WHERETO modelidagi \"H\" (Hook) bosqichining vazifasi nima?", options: ["Bolalarning qiziqishini uyg'otish", "Yakuniy baholash", "Uy vazifasini berish", "Natijani qayd etish"], correct: 0 },
            { q: "GRASPS modeli qanday topshiriqlarni loyihalashga yo'naltirilgan?", options: ["Yodlashga asoslangan", "Real hayotiy vaziyatga asoslangan amaliy", "Faqat og'zaki savol-javob", "Yozma diktant"], correct: 1 },
            { q: "\"Qo'sh daraxt\" metodi qaysi turdagi vosita hisoblanadi?", options: ["Grafik organayzer", "Harakatli o'yin", "Musiqiy mashg'ulot", "Test topshirig'i"], correct: 0 },
            { q: "Koreya maktabgacha ta'lim tizimida asosiy e'tibor nimaga qaratilgan?", options: ["Faqat akademik tayyorgarlikka", "O'yin va bolaga yo'naltirilgan Nuri o'quv dasturiga", "Imtihonlarga tayyorlashga", "Faqat jismoniy tarbiyaga"], correct: 1 },
            { q: "Mashg'ulot samaradorligini baholashda eng to'g'ri yondashuv qaysi?", options: ["Faqat tarbiyachi fikri", "Bolalar rivojlanishidagi o'zgarishlarni kuzatish va qayd etish", "Mashg'ulot davomiyligi", "Ishlatilgan ko'rgazmalar soni"], correct: 1 },
            { q: "Kasbiy-metodik kompetensiya deganda nima tushuniladi?", options: ["Faqat nazariy bilimlar yig'indisi", "Bilim, ko'nikma, motivatsiya va refleksiyaning integrativ birligi", "Diplomdagi baholar", "Ish staji"], correct: 1 },
        ],
    },
    {
        id: "activity",
        title: "Faoliyatli (operatsional) komponent",
        short: "Faoliyatli",
        icon: "icon-graduation",
        description: "Pedagogik vaziyatlarda metodni to'g'ri tanlash, mashg'ulotni loyihalash va tashkil etish ko'nikmalari.",
        type: "test",
        items: [
            { q: "Mashg'ulot boshida bolalar charchagan va e'tiborsiz. Tarbiyachi sifatida birinchi navbatda nima qilasiz?", options: ["Mavzuni tushuntirishni davom ettiraman", "Qisqa harakatli o'yin yoki qiziqarli savol bilan e'tiborni jalb qilaman", "Bolalarga tanbeh beraman", "Mashg'ulotni bekor qilaman"], correct: 1 },
            { q: "Guruhda nutqi sust rivojlangan bola bor. Unga qaysi yondashuv mos?", options: ["Uni mashg'ulotdan chetlatish", "Individual topshiriq va juftlikda ishlash imkoniyatini yaratish", "Boshqalar oldida ko'proq gapirishga majburlash", "E'tibor bermaslik"], correct: 1 },
            { q: "\"Fasllar\" mavzusida bolalar bilimini tizimlashtirmoqchisiz. Qaysi metod eng mos?", options: ["Qo'sh daraxt (grafik organayzer)", "Faqat ma'ruza", "Diktant", "Uy vazifasi"], correct: 0 },
            { q: "Mashg'ulot maqsadini qanday ifodalash to'g'ri?", options: ["\"Bolalarga hayvonlar haqida gapirib berish\"", "\"Mashg'ulot oxirida bolalar 5 ta uy hayvonini nomlay oladi va ularning foydasini ayta oladi\"", "\"Yaxshi mashg'ulot o'tkazish\"", "\"Bolalar xursand bo'lsin\""], correct: 1 },
            { q: "Bolalarga \"Do'kon\" syujetli-rolli o'yinini tashkil etmoqchisiz. Bu qaysi model g'oyasiga yaqin?", options: ["GRASPS — real vaziyat va rolga asoslangan topshiriq", "SQ3R — matn bilan ishlash", "Faqat test", "Ma'ruza"], correct: 0 },
            { q: "Mashg'ulotdan so'ng natijani qanday tahlil qilasiz?", options: ["Tahlil qilmayman", "Maqsadga erishilganini kuzatuv natijalari asosida baholab, keyingi mashg'ulotga xulosa chiqaraman", "Faqat hamkasblardan so'rayman", "Bolalarga baho qo'yaman"], correct: 1 },
        ],
    },
    {
        id: "reflexive",
        title: "Refleksiv komponent",
        short: "Refleksiv",
        icon: "icon-check",
        description: "O'z kasbiy faoliyatini tahlil qilish, xatolarni anglash va o'z-o'zini rivojlantirishga tayyorlik.",
        type: "likert",
        items: [
            "Har bir mashg'ulotdan so'ng nima yaxshi va nima yomon bo'lganini tahlil qilaman.",
            "O'z xatolarimni tan olib, ularni tuzatish yo'llarini izlayman.",
            "Kasbiy bilim va ko'nikmalarimdagi bo'shliqlarni aniq bilaman.",
            "O'qituvchi va hamkasblarning tanqidiy fikrini xotirjam qabul qilaman.",
            "O'zimni kasbiy rivojlantirish bo'yicha aniq rejam bor.",
            "Tanlagan metodim nima uchun mos ekanini asoslab bera olaman.",
        ],
    },
];

// Komponent bo'yicha foiz ko'rsatkichini hisoblash
export const scoreComponent = (component, answers = {}) => {
    const n = component.items.length;
    if (component.type === "likert") {
        // 1..5 shkala -> 0..100%
        const sum = component.items.reduce((acc, _, i) => acc + (answers[i] ?? 1), 0);
        return Math.round(((sum - n) / (4 * n)) * 100);
    }
    const correct = component.items.reduce((acc, item, i) => acc + (answers[i] === item.correct ? 1 : 0), 0);
    return Math.round((correct / n) * 100);
};

export const overallScore = (scores) => {
    const vals = components.map((c) => scores[c.id] ?? 0);
    return Math.round(vals.reduce((a, b) => a + b, 0) / vals.length);
};

// Talabaning o'quv yo'li (Talabalar bo'limida ko'rsatiladi)
export const learningPath = [
    { step: 1, title: "Kirish diagnostikasi", text: "Kasbiy-metodik kompetensiyangizning boshlang'ich darajasini aniqlang.", path: "/diagnostics?stage=pre", key: "pre" },
    { step: 2, title: "O'quv ishlanmalari", text: "7 ta metod bo'yicha tayyor amaliy mashg'ulot ishlanmalari: namuna, topshiriq, ish varag'i.", path: "/student-modules", key: "modules" },
    { step: 3, title: "Xorij tajribasi", text: "AQSH, Germaniya, Janubiy Koreya va Rossiya maktabgacha ta'lim tajribasi.", path: "/experiments" },
    { step: 4, title: "Bilim testi", text: "Har bir metod bo'yicha testdan o'ting va sertifikat oling.", path: "/quiz" },
    { step: 5, title: "Pedagogik keyslar", text: "Real vaziyatlarda to'g'ri metodik qaror qabul qilishni mashq qiling.", path: "/cases" },
    { step: 6, title: "Ijodiy topshiriq", text: "Metodik ruletka shartlari asosida mashg'ulot yoki didaktik o'yin loyihalang.", path: "/challenge" },
    { step: 7, title: "Refleksiv kundalik", text: "Amaliyotdagi har bir mashg'ulotingizni tahlil qilib, portfolio yarating.", path: "/reflection" },
    { step: 8, title: "Chiqish diagnostikasi", text: "Yakuniy diagnostika orqali o'sish dinamikangizni ko'ring.", path: "/diagnostics?stage=post", key: "post" },
];
